define([
	'internal_util/Logger',
	'service/UIStateManager',
	'internal_util/Util',
	'internal_util/Configuration',
	'internal_util/ClientUtil',
	
	'factory/CloudIdentityFactory',
	
	'@ecsec/base-libs/dist/pairing/protocol'
], function (
		Logger,
		UIStateManager,
		Util,
		Configuration,
		ClientUtil,
		
		CloudIdentityFactory,
		
		protocol
		) {
	'use strict';

	/**
	 * MessageBrokerManager class
         * IMPORTANT: Apache WS-Tunnle module must be loaded on the backend
	 */
	return function (uiStateManager) {
		
		function log(method, message, data) {
			Logger.log('BindingState', method, message, data);
		}
		
		var _uiStateManager = uiStateManager;

		var _url = Configuration.get('PAIRING_URL'),
				connection = null;
		
		var STATE_HELLO = 0, STATE_TRUST = 1, STATE_LINK = 2, STATE_FINISH = 3,
			STATE = -1;
	
		var masterIdS = new protocol.NumericKeyExchangeInitiator("masterIdS");
		var slaveIdS = new protocol.NumericKeyExchangeInitiatee("slaveIdS");
		
		var link = null;
		
		var secOut = null;
		var secIn = null;
		
		var _isMasterIdS = false;
		var remoteAdr = "";
		var selfAdr = "";
		var remoteVersion;
		var selfVersion = 1;
		
		var remoteCallbacks = {};
		
		var endpoint = null;
		

		// private methods

		function connect(callback, toUrl) {
			if (connection !== null && connection.readyState === 1)
			{
				closeConnection();
			}
			var entityUrl = _url + getMessageBrokerEntityUrl();
			if(Util.isValidURL(toUrl)) {
				connection = new WebSocket(toUrl, "de.skidentity.pairing");
			} else {
				connection = new WebSocket(entityUrl, "de.skidentity.pairing");
			}

			connection.onopen = function () {
				STATE = STATE_HELLO;

				masterIdS.init();
				slaveIdS.init();

				if(!Util.isValidURL(toUrl)) {
					callback({typ:"Initialization", entityUrl:entityUrl});
				}
			};

			connection.onmessage = function (e) {
				_isMasterIdS = !Util.isValidURL(toUrl);
				parseMessage(e, callback);
			};

			connection.onclose = function () {
				log("WebSocket->onclose");
				closeConnection();
				callback({typ:"Closed"});
			};

			connection.onerror = function (evt) {
				log("WebSocket->onerror","IMPORTANT: Apache WS-Tunnle module must be loaded on the backend",evt);
				closeConnection();
				callback({typ:"Closed", message:evt});
			};
		};
		
		function closeConnection() {
			if (connection) {
				connection.close();
			}
			connection = null;
			endpoint = null;
		};
		
		function parseMessage(message, callback) {
			message = JSON.parse(message.data);
			switch(message.typ) {
				case "Hello":
					remoteAdr = message.adr;
					selfAdr = message.self;
					remoteVersion = message.version;
					if(_isMasterIdS) {
						STATE = STATE_TRUST;
						connection.send(JSON.stringify(masterIdS.provideIdentification()));
					}
					break;
				case "Trust":
				case "Link":
					pairingProtocol(message, callback);
					break;
				case "Enc":
					remoteControl(decryptMessage(message));
					break;
				default:
					callback(message);
			}
		};
		
		function pairingProtocol(message, callback) {
			switch(STATE) {
				case STATE_HELLO:
					log("pairingProtocol", "STATE_HELLO", message);
					connection.send(JSON.stringify(slaveIdS.receiveIdentification(message)));
					callback({typ:"Hello",txt:slaveIdS.getVisualConfirmation(),adr:remoteAdr});
					
					link = new protocol.LinkEstablishment(false, selfAdr, remoteAdr, selfVersion.toString(), remoteVersion.toString(), "session");
					link.loadParameters(slaveIdS.exportParameters());
					STATE = STATE_LINK;
					break;
				case STATE_TRUST:
					log("pairingProtocol", "STATE_TRUST", message);
					masterIdS.receiveIdentification(message);
					callback({typ:"Hello",txt:masterIdS.getVisualConfirmation(),adr:remoteAdr});
					
					link = new protocol.LinkEstablishment(true, selfAdr, remoteAdr, selfVersion.toString(), remoteVersion.toString(), "session");
					link.loadParameters(masterIdS.exportParameters());
					STATE = STATE_LINK;
					break;
				case STATE_LINK:
					log("pairingProtocol", "STATE_LINK", message);
					if (link.isOtherConfirmationValid(message)) {
						if(!_isMasterIdS){
							connection.send(JSON.stringify(link.getOwnConfirmationValue()));
						}		

						var nonce_self = link.exportParameters().nonce_self;
						var nonce_other = link.exportParameters().nonce_other;
						
						secOut = new protocol.SecureChannelOut(link.getLinkKey(), nonce_self);
						secIn = new protocol.SecureChannelIn(link.getLinkKey(), nonce_other);
						
						STATE = STATE_FINISH;
						if (remoteCallbacks.hasOwnProperty(STATE)) {
							remoteCallbacks[STATE]();
						}
					}
					break;
				case STATE_FINISH:
					log("pairingProtocol", "STATE_FINISH", message);
					var nonce_self = link.exportParameters().nonce_self;
					var nonce_other = link.exportParameters().nonce_other;
					
					secOut = new protocol.SecureChannelOut(link.getLinkKey(), nonce_self);
					secIn = new protocol.SecureChannelIn(link.getLinkKey(), nonce_other);
					break;
			}
		};
		
		function getMessageBrokerEntityUrl() {
			if (endpoint === null) {
				var version = "";
				if (_url.endsWith('/')) {
					version += selfVersion+"/";
				} else {
					version += "/"+selfVersion+"/";
				}
				endpoint = version + Util.randomString(8);
			}
			return endpoint;
		};
		
		function remoteControl(message) {
			log("remoteControl", "received remote message", message);
			switch (message.typ) {
				case "RegisterBindingReq":
					_uiStateManager.change('binding', {
						remote : true,
						"session" : message["session"],
						nonce: message.nonce,
						'bind-type': message['bind-type']
					});
					break;
				default:
					remoteCallbacks[message.typ](message);
					break;
			}
		};
		
		function sendEncMessage(message) {
			var encMessage = secOut.encrypt_toB64(JSON.stringify(message));
			
			connection.send(JSON.stringify({typ:"Enc",enc:encMessage}));
		}
		
		function decryptMessage(message) {
			var decMessage = JSON.parse(secIn.decrypt_fromB64(message.enc));
			return decMessage;
		}

		// public methods
		
		this.open = function (callback, url) {
			connect(callback, url);
		};
		
		this.close = function () {
			closeConnection();
		};
		
		this.isMasterIdS = function () {
			return _isMasterIdS;
		};
		
		this.isOpen = function () {
			return connection !== null && STATE === STATE_FINISH;
		};
		
		this.getEndpoint = function () {
			return getMessageBrokerEntityUrl();
		};
		
		this.continueWithLink = function(callback) {
			if(_isMasterIdS) {
				remoteCallbacks[STATE_FINISH] = callback;
				connection.send(JSON.stringify(link.getOwnConfirmationValue()));
			}
		};
		
		this.sendMessage = function(message) {
			sendEncMessage(message);
		};
		
		this.sendBinding = function(bindData, callback) {
			remoteCallbacks['SaveCloudID'] = callback;
			sendEncMessage({
				typ:"RegisterBindingResp",
				'bind-data':bindData
			});
		};

		this.getBinding = function(session, callback) {
			remoteCallbacks['RegisterBindingResp'] = callback;
			sendEncMessage({
				typ:"RegisterBindingReq",
				"session": session,
				'bind-type':'http://ws.skidentity.de/ci/binding/key/v1.0',
				nonce:Util.randomString(20)
			});
		};
		
		this.sendCloudID = function(cid, callback) {
			remoteCallbacks['Finish'] = callback;
			sendEncMessage({
				typ:"SaveCloudID",
				cid:cid
			});
		};
		
		this.finish = function() {
			sendEncMessage({
				typ:"Finish"
			});
			closeConnection();
		};

	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/MessageBrokerManager.js
// module id = 304
// module chunks = 4